import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../../app/store/hooks/Redux'
import { SeoPositionChartArg, useGetResearchSeoPositionChartQuery } from '../../../../app/api'
import { GraphReport } from '../../../../shared/components/cards/graph-report/GraphReport'
import React, { useEffect, useState } from 'react'
import { BpTooltip } from '../../../../shared/components/cards/tooltip/BpTooltip'
import {
  changeChartDataRange,
  selectPositionTrackerChart,
  selectPositionTrackerFilters,
} from '../../model/positionTrackerSlice'
import { PositionTrackerFilterInterface } from '../../model/types/PositionTrackerFilter.interface'
import { PositionTrackerChartInterface } from '../../model/types/PositionTrackerChart.interface'
import { EDateRangeType } from '../../../advertising-research/model/types/DateRangeType.enum'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import styles from './PositionTrackerChart.module.scss'
import { useMenuLayout } from '../../../../app/layouts/main-layout/hooks/UseMenuLayout'
import { selectedOptionTexts } from '../../../../shared/lib/helpers/WithSelectedOptions'

export const PositionTrackerChart = () => {
  const { t } = useTranslation()
  const { menuLayout } = useMenuLayout()
  const dispatch = useDispatch()
  const { project, site, country, engine_id, keyword } =
    useAppSelector<PositionTrackerFilterInterface>(selectPositionTrackerFilters)
  const { dateRange: filter, chartIds } = useAppSelector<PositionTrackerChartInterface>(
    selectPositionTrackerChart,
  )
  const { date, group: date_group } = filter
  const [queryParams, setQueryParams] = useState<SeoPositionChartArg>()

  const { data, currentData } = useGetResearchSeoPositionChartQuery(
    queryParams as SeoPositionChartArg,
    {
      skip:
        project === undefined ||
        !project.length ||
        !site.length ||
        !country ||
        !chartIds?.length ||
        !queryParams,
    },
  )
  const [dataProject, setDataProject] = useState(project)

  useEffect(() => {
    if (currentData) setDataProject(project)
  }, [currentData])

  useEffect(() => {
    if (!chartIds?.length) return

    setQueryParams({
      body: {
        date_group,
        date,
        project_id: +project,
        site: site,
        country_id: +country,
        engine_id: engine_id,
        keyword: selectedOptionTexts('keyword', keyword),
        keyword_ids: chartIds as unknown as number[],
      },
    })
  }, [chartIds])

  return (
    <GraphReport
      reversed
      header={
        menuLayout === 'top' && (
          <h3 className={clsx(styles.title)}>
            {t('pages.positionTracker.seoPositionTracker')}
            <BpTooltip title={t('pages.positionTracker.seoPositionTrackerTooltip')} />
          </h3>
        )
      }
      exceptionsDates={[EDateRangeType.WEEK]}
      filter={filter}
      groupSelector={false}
      name={t('pages.positionTracker.seoPositionTracker')}
      series={chartIds?.length ? (dataProject === project ? data : currentData) : undefined}
      title={menuLayout === 'top' ? t('pages.positionTracker.seoPositionTracker') : null}
      yMin={1}
      yTickInterval={1}
      onChange={(e) => dispatch(changeChartDataRange(e))}
    />
  )
}
